export default function Description() {
  return (
    <section
      id="pscribes-tts"
      style={{
        maxWidth: "900px",
        margin: "2rem auto",
        padding: "1.25rem 1.5rem",
        border: "1px solid #e5e7eb",
        borderRadius: "16px",
        background: "#fff",
        boxShadow: "0 2px 10px rgba(0,0,0,.04)",
        fontFamily:
          "system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,'Helvetica Neue',Arial,'Apple Color Emoji','Segoe UI Emoji'",
        color: "#111827",
      }}
    >
      <h1 style={{ fontSize: "1.75rem", lineHeight: "1.2", margin: "0 0 .75rem 0" }}>
        PScribes TTS AI – Free Text-to-Speech AI Tool
      </h1>
      <p style={{ margin: ".5rem 0 1rem 0", fontSize: "1rem", lineHeight: "1.65" }}>
        PScribes TTS AI is a <strong>free text-to-speech tool</strong> that provides high-quality
        speech synthesis and supports multiple languages, including{" "}
        <em>
          English, Hindi, French, German, Spanish, Chinese, Japanese, Korean,
          Vietnamese
        </em>
        , and more—plus a variety of voice styles. Use it to read text and
        e-books aloud, or <strong>download audio files</strong>{" "}
        (completely free).
      </p>

      <hr
        style={{
          border: "none",
          borderTop: "1px solid #edeef0",
          margin: "1rem 0 1.25rem 0",
        }}
      />

      <h2 style={{ fontSize: "1.25rem", margin: "0 0 .75rem" }}>Quick Tutorial</h2>
      <ol style={{ listStyle: "none", counterReset: "step", padding: 0, margin: 0 }}>
        {[
          {
            num: 1,
            title: "Enter text",
            desc: (
              <>
                Paste or type the text to convert to speech. The current limit is{" "}
                <strong>2000 characters</strong> per request.
              </>
            ),
          },
          {
            num: 2,
            title: "Select language and voice",
            desc: (
              <>
                Choose the language and your preferred voice style. Each language includes
                multiple voices.
              </>
            ),
          },
          {
            num: 3,
            title: "Convert text to speech",
            desc: (
              <>
                Click <em>Convert to Speech</em> to start.
              </>
            ),
          },
          {
            num: 4,
            title: "Listen and download",
            desc: (
              <>
                After conversion, listen online or download the audio file for your
                projects.
              </>
            ),
          },
        ].map(({ num, title, desc }) => (
          <li
            key={num}
            style={{
              display: "flex",
              gap: ".75rem",
              alignItems: "flex-start",
              margin: ".5rem 0",
              counterIncrement: "step",
            }}
          >
            <div
              style={{
                flex: "0 0 auto",
                width: "28px",
                height: "28px",
                borderRadius: "9999px",
                background: "#eef2ff",
                color: "#4338ca",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: ".9rem",
              }}
            >
              <span style={{ userSelect: "none" }}>{num}</span>
            </div>
            <div>
              <strong>{title}</strong>
              <div style={{ color: "#374151", fontSize: ".975rem", lineHeight: "1.6" }}>
                {desc}
              </div>
            </div>
          </li>
        ))}
      </ol>
	  
	        {/* Popular Languages */}
      <div style={{ marginTop: "2rem" }}>
        <h2
          style={{
            fontSize: "1.25rem",
            fontWeight: "700",
            marginBottom: ".75rem",
          }}
        >
          Popular Languages and TTS AI Voices We Support
        </h2>
        <p style={{ marginBottom: "1rem", color: "#374151" }}>
          Easily convert text to speech, choose your favorite language and voice:
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
            gap: "0.75rem",
            fontWeight: "600",
            color: "#111827",
          }}
        >
          <div>ENGLISH</div>
          <div>CHINESE</div>
          <div>HINDI</div>
          <div>SPANISH</div>
          <div>FRENCH</div>
          <div>ITALIAN</div>
          <div>JAPANESE</div>
          <div>BRAZILIAN</div>
          <div>VIETNAMESE</div>
          <div>KOREAN</div>
          <div>THAI</div>
          <div>PORTUGUESE</div>
        </div>
      </div>

    </section>
  );
}
